import { createApp } from "vue";
import store from "../../common/js/store";
import registerServiceWorker from "./serviceWorkerRegistration";

// Global components import
import InitializeSaveAddress from "../../common/js/components/InitializeSaveAddress.vue";
import ToastMsg from "../../common/js/components/ToastMsg.vue";
import Loader from "../../common/js/components/Loader.vue";
import AddEditAddressForm from "../../common/js/components/AddEditAddressForm.vue";
import Ripple from "../../common/js/helpers/ripple";

const app = createApp({});
app.use(store);

// Global components registration
// @todo: similarly all other components registration currently inside Home.vue will move here and Home.vue will be discarded
app.directive("ripple", Ripple);
app.component("initialize-save-address", InitializeSaveAddress);
app.component("toast-msg", ToastMsg);
app.component("loader", Loader);
app.component("add-edit-address-form", AddEditAddressForm);

app.mount("#themeDefaultSaveAddress");

// @todo : uncomment this...

registerServiceWorker();

if (typeof window != "undefined") {
  window.onbeforeunload = () => {
    window.scrollTo(0, 0);
  };
}
